import { HouseAffordabilityCalculator } from "../Apps/HouseAffordabilityCalculator"

function AppHouseAffordabilityCalculator() {

  return (
    <HouseAffordabilityCalculator />
  )
}

export default AppHouseAffordabilityCalculator

